import { GeneralResponse } from '../models/generalResponse'

export function prevalidateUser(userRepository, contextData, usersData) {
  return userRepository.prevalidate(contextData, usersData).then(data => new GeneralResponse(data));
}